/** Duet / choir parts — mirrors backend/vocal_arrangement.py so the editor shows what the engine will get. */
const HEADER_RE = /^\s*\[([^\]]+)\]\s*$/;
const GROUP = ["chorus", "hook", "refrain", "vamp", "outro", "intro", "tag"];

export const DEFAULT_ARRANGEMENT = { type: "solo", partner: { kind: "female", profile_id: null }, parts: [] };
export const SINGER_KEYS = { duet: ["lead", "partner", "both"], choir: ["lead", "choir", "call_response"] };
export const MY_SINGERS = { duet: ["lead", "both"], choir: ["lead", "call_response"] };

export function parseSections(lyrics) {
  const out = [];
  (lyrics || "").split("\n").forEach((line, i) => {
    const m = line.match(HEADER_RE);
    if (m) out.push({ label: m[1].split(":")[0].trim().slice(0, 40) || "Section", line: i });
  });
  return out;
}

function defaultSingers(labels, kind) {
  let verses = 0;
  let lastVerse = "lead";
  return labels.map((label) => {
    const low = label.toLowerCase();
    if (kind === "duet") {
      if (low.includes("pre")) return lastVerse;
      if (low.includes("verse")) { verses += 1; lastVerse = verses % 2 ? "lead" : "partner"; return lastVerse; }
      if (GROUP.some((g) => low.includes(g)) || low.includes("bridge")) return "both";
      return "lead";
    }
    if (low.includes("pre")) return "lead";
    if (low.includes("call") || ["chorus", "hook", "refrain", "vamp", "tag", "outro"].some((g) => low.includes(g))) return "call_response";
    if (low.includes("bridge") || low.includes("intro")) return "choir";
    return "lead";
  });
}

export function normalizeParts(lyrics, arrangement) {
  const kind = arrangement?.type;
  if (!SINGER_KEYS[kind]) return [];
  const labels = parseSections(lyrics).map((s) => s.label);
  const given = arrangement.parts || [];
  const defaults = defaultSingers(labels, kind);
  return labels.map((label, i) => {
    const g = given[i];
    const ok = g && g.label === label && SINGER_KEYS[kind].includes(g.singer);
    return { label, singer: ok ? g.singer : defaults[i] };
  });
}

/** Section occurrences in time order (first pass + repeats the engine added). */
export function sectionTimeline(backing) {
  return [...(backing?.sections || []), ...(backing?.repeats || [])]
    .filter((s) => s.end > s.start)
    .sort((a, b) => a.start - b.start);
}

/** The section being sung at time t (index into the lyric's sections), or -1. */
export function sectionAt(timeline, t) {
  const hit = timeline.find((s) => t >= s.start - 0.5 && t <= s.end + 0.5);
  return hit ? hit.index : -1;
}

/** Lyric blocks for the prompter: [{label, singer, lines}] (text before the first header becomes an intro block). */
export function lyricBlocks(lyrics, parts) {
  const lines = (lyrics || "").split("\n");
  const secs = parseSections(lyrics);
  const blocks = [];
  const pre = (secs.length ? lines.slice(0, secs[0].line) : lines).filter((l) => l.trim());
  if (pre.length) blocks.push({ index: -1, label: secs.length ? "Intro" : "Lyrics", singer: null, lines: pre });
  secs.forEach((s, k) => {
    const end = k + 1 < secs.length ? secs[k + 1].line : lines.length;
    blocks.push({ index: k, label: s.label, singer: parts?.[k]?.singer || null, lines: lines.slice(s.line + 1, end).filter((l) => l.trim()) });
  });
  return blocks;
}
